import {FaAward} from 'react-icons/fa';
import {TbBooks} from 'react-icons/tb';

const data = [
    {id: 1, icon: <FaAward/>, title: 'Experience', desc : "1+ years experience"},

    {id: 2, icon: <TbBooks/>, title: 'Projects', desc : "15+ completed"}
]
export default data;